module.exports = __webpack_public_path__ + "img/be01290.png";